import { api } from './utils'
import { IUploadServerAnswer } from './customization'

export async function sendRestoreRequest(email: string): Promise<IUploadServerAnswer> {
	const request = await fetch(`${api}/restore`, {
	    method: 'POST',
		body: JSON.stringify({ email })
	})

	return await request.json() as IUploadServerAnswer
}
